import { ServiceMeterReadingProp } from '../../../../types';
import { CatHeading } from '@blocks-react/components/Heading';
import styles from '../../../../VisionLink.module.scss';
import cx from 'classnames';
import { VisionLinkTooltip } from '../../VisionLinkTooltip';

export const ServiceMeterReading = ({
meterInfo,
unitLabel,
tooltipMessage
}: ServiceMeterReadingProp) => {
  return (
    <>
      <CatHeading variant="display-sm" className="ms-2 me-1">
        {meterInfo}
      </CatHeading>
      <CatHeading variant="body-sm">
        <span className={cx('me-2', styles['c-vision-link-cards-text'])}>
           {unitLabel}
        </span>
      </CatHeading>
      <VisionLinkTooltip position="top">
        {tooltipMessage}
      </VisionLinkTooltip>
    </>
  );
};
